import { render } from "./pieChart1.vue?vue&type=template&id=b1fc8b9c&scoped=true"
import script from "./pieChart1.vue?vue&type=script&lang=js"
export * from "./pieChart1.vue?vue&type=script&lang=js"

import "./pieChart1.vue?vue&type=style&index=0&id=b1fc8b9c&scoped=true&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1fc8b9c"]])

export default __exports__